import { useTranslation } from "src/translations";
import { HorizontalFormFieldStyle } from "../../../Form/formFieldLabelPositioning/styles/Styles";
import type { FieldMethod, FormFieldFactoryProps } from "../../../Form/types/types";
import { DisplayText } from "./DisplayText";

export const EditableListDisplayTextField: FieldMethod = ({ field, rules }: FormFieldFactoryProps) => {
    const { t } = useTranslation();

    return (
        <HorizontalFormFieldStyle key={`${field.name}FormItem`} name={field.name} rules={rules} label={t(field.translationKeys.label)}>
            <DisplayText key={field.name} />
        </HorizontalFormFieldStyle>
    );
};
